exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#year-selector{\n    right:10px;\n    position:absolute;\n    top:1435px;\n    height:30px;\n    width:150px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/components/year-selector/year-selector.component.css
// module id = ../../../../../src/app/components/year-selector/year-selector.component.css
// module chunks = main